import React, { Component } from 'react'
import { colorForString } from '../../utils/usercolor'

require('./nicklist.scss')

export default class Nicklist extends Component {
  render() {
    return <div className="nicklist">{this.nicklist()}</div>
  }

  nicklist() {
    const users = this.props.users.map(
      function(user) {
        return (
          <div key={user} className="nicklist-entry" onClick={this.props.usernameSelected.bind(this, user)}>
            <span style={{ color: colorForString(user) }}>{user}</span>
          </div>
        )
      }.bind(this),
    )
    return users
  }
}



// WEBPACK FOOTER //
// ./src/views/nicklist/Nicklist.jsx